export const veridionPagePL = {
  "seo": {
    "title": "Veridion Agentic Company Intelligence | Organizacja pracowników AI",
    "description": "Następny poziom produktywności: Organisation as a Service. Organizacja pracowników AI dostarcza zweryfikowaną pracę, planowalną w stałych cyklach, on-premises lub w Państwa chmurze."
  },
  "hero": {
    "kicker": "Veridion Agentic Company Intelligence",
    "title": "Jeden twórca, nieskończenie wiele rozwiązań.",
    "claim": "Następny poziom produktywności: Organisation as a Service.",
    "lead": "Firmowa AI, która steruje całą pAIoneer Labs GmbH: kadra pracowników AI, która integruje się z każdym procesem Państwa przedsiębiorstwa, samodzielnie doprowadza pracę do końca i uczy się z każdym zadaniem. Ludzie wyznaczają kierunek. Cała reszta dzieje się sama."
  },
  "vision": {
    "lines": [
      "Oprogramowanie dało firmom narzędzia.",
      "AI dała im asystentów.",
      "Veridion daje im organizację."
    ],
    "note": "Informacje poruszają się w godzinach, doświadczenie odchodzi na emeryturę, stanowiska pozostają nieobsadzone. Kolejne narzędzie tego nie rozwiąże; rozwiąże to kadra, której nie trzeba zatrudniać."
  },
  "grow": {
    "title": "Czego nie potrafi, to tworzy",
    "text": "Tam, gdzie dla danego zadania nie istnieje jeszcze odpowiednia umiejętność lub czegoś nie da się rozwiązać obecnymi środkami, Veridion samodzielnie tworzy nowe, dowolnie złożone systemy AI — sztuczna inteligencja sama rozwija sztuczną inteligencję: projektuje, buduje, testuje i wdraża do pracy. Wyłącznie zatwierdzenie pozostaje po stronie człowieka poprzez [Intent-Driven Development](idd) (IDD).",
    "punch": "Dokładnie to znaczy: jeden twórca, nieskończenie wiele rozwiązań."
  },
  "integrate": {
    "title": "W samym środku Państwa procesów",
    "subtitle": "Żadnego nowego oprogramowania, żadnych szkoleń, żadnej migracji.",
    "cards": [
      {
        "title": "W czacie firmowym",
        "text": "Rozmowa toczy się tam, gdzie Państwa ludzie i tak piszą: Webex, Microsoft Teams, Zoom, Slack. Wystarczy jedna wiadomość."
      },
      {
        "title": "W Państwa narzędziach",
        "text": "Zarządzanie projektami, repozytoria, obieg dokumentów: praca odbywa się w systemach, które już są, a nie obok nich."
      },
      {
        "title": "Od oferty po księgowość",
        "text": "Jeden proces po drugim, w Państwa tempie. Gdy mocy przerobowych brakuje, także pojedynczy pakiet rozwojowy albo cały projekt."
      }
    ]
  },
  "org": {
    "title": "Kadra zorganizowana jak przedsiębiorstwo",
    "subtitle": "Nie narzucamy żadnej firmie sztywnego szablonu: dla każdej struktury przedsiębiorstwa projektujemy indywidualny organigram, przypisujemy przejrzyste role i zakresy odpowiedzialności oraz elastycznie się dopasowujemy. Każda jednostka biznesowa składa się z pracowników AI orkiestrowanych przez Veridion, którzy pracują w pełni automatycznie aż do [IDD](idd) Human-in-the-Loop — a gdy czegoś jeszcze nie da się zrobić, Veridion sam tworzy nową AI.",
    "execKicker": "Warstwa koordynacji — w pełni zautomatyzowana aż do IDD Human-in-the-Loop",
    "execTitle": "Indywidualny organigram, przejrzyste role i AI, która sama rozwija AI.",
    "execText": "Poniżej ludzkich decydentów warstwa koordynacji oraz jednostki biznesowe złożone z pracowników AI działają w pełni automatycznie: dzielą cele, rozdzielają pracę pomiędzy jasno zdefiniowane role i obowiązki, samodzielnie rozwiązują problemy i występują o celowe zatwierdzenia od człowieka. Człowiek w pętli steruje poprzez [Intent-Driven Development](idd) (IDD) — daleko poza kodem oprogramowania, jako wspólne kierowanie człowieka i AI poprzez intencje, decyzje i scenariusze weryfikacji. A ilekroć brakuje jakiejś zdolności, Veridion samodzielnie projektuje i buduje nowe, dowolnie złożone systemy AI — AI rozwija AI.",
    "units": [
      {
        "name": "Rozwój oprogramowania",
        "text": "Odpowiada za oprogramowanie od wymagania po eksploatację: architekturę, kod, testy, przeglądy, pipeline’y i stojącą za nimi jakość."
      },
      {
        "name": "Elektronika i firmware",
        "text": "Odpowiada za stronę sprzętową: układy, firmware i wybór każdego podzespołu."
      },
      {
        "name": "Obliczenia kwantowe i kwantowa AI",
        "text": "Odpowiada za badania nad obliczeniami kwantowymi i kwantową AI oraz przekuwa solidne wyniki w produkty."
      },
      {
        "name": "Sprzedaż i marketing",
        "text": "Odpowiada za rynek: obserwuje go, znajduje klientów docelowych, opracowuje dossier, projektuje teksty i oferty. Transakcję zamyka człowiek."
      },
      {
        "name": "Produkty i eksploatacja platformy",
        "text": "Odpowiada za produkty i eksploatację: strategię, priorytety, wydania, do tego monitorowanie, incydenty i zasoby działającej platformy."
      },
      {
        "name": "Administracja i finanse",
        "text": "Odpowiada za sprawy administracyjne i finansowe: dowody księgowe, faktury, umowy, terminy, przygotowane aż po podpis, a ten pozostaje w Państwa rękach."
      }
    ]
  },
  "trust": {
    "title": "Na czym mogą Państwo polegać",
    "cards": [
      {
        "title": "Human-in-the-Loop oraz IDD daleko poza samym kodem",
        "text": "Intent-Driven Development ([IDD](idd)) sięga znacznie dalej niż kod oprogramowania: to sposób, w jaki człowiek w pętli współpracuje z AI we wszystkich obszarach firmy. Człowiek i AI wspólnie formułują intencję (Intent), podejmują wiążące decyzje (Decisions) i definiują weryfikowalne scenariusze (Scenarios), zanim zespół AI samodzielnie wykona pracę w stałych, przewidywalnych cyklach, a człowiek zatwierdzi rezultat."
      },
      {
        "title": "Komunikacja zoptymalizowana teorią gier",
        "text": "Zarządzanie projektami i komunikacja pracowników AI są zoptymalizowane teorią gier, od pojedynczego pracownika AI po całą jednostkę biznesową: rzetelność i uzasadniony sprzeciw popłacają; zatwierdzanie bez namysłu, powtarzanie się i spychanie odpowiedzialności kosztują. Tak wygrywa najlepsza komunikacja."
      },
      {
        "title": "Wyjaśnialna aż do źródła",
        "text": "Explainable AI jest tu zasadą pracy, a nie dodatkiem: każdy rezultat ujawnia, z czego powstał — znalezione fragmenty wiedzy firmowej, dane, tok obliczeń. Czego nie potwierdza żadne źródło, tego się nie twierdzi."
      },
      {
        "title": "Uczy się samodzielnie",
        "text": "Po każdym przebiegu odczytywane są własne wskaźniki i odpowiednio dostosowywane własne reguły: każdy prowadzony projekt ulepsza całość."
      }
    ]
  },
  "daily": {
    "title": "Co już dziś jest przejmowane",
    "subtitle": "Każdego dnia, w całym przedsiębiorstwie.",
    "items": [
      {
        "title": "Rozwój",
        "text": "Kod, testy i dokumentacja z utrwalonych decyzji. Modernizacja wieloletniego oprogramowania z dowodami golden master i back-to-back."
      },
      {
        "title": "Elektronika i firmware",
        "text": "Analizowanie kart katalogowych, symulowanie układów jako cyfrowych bliźniaków, rozwijanie firmware i ocenianie alternatywnych podzespołów, zanim cokolwiek zostanie zbudowane, blisko sprzętu, aż po sam sensor."
      },
      {
        "title": "Badania kwantowe",
        "text": "Lektura stanu techniki, budowanie i ocena powtarzalnych eksperymentów względem klasycznych punktów odniesienia, każdy wynik utrwalony w sposób możliwy do prześledzenia."
      },
      {
        "title": "Analiza danych",
        "text": "SQL Server, MariaDB, MySQL i Oracle: typowany plan analizy, zapytania wyłącznie do odczytu, statystyka liczona w środowisku wykonawczym, raporty z jednego wersjonowanego wyniku."
      },
      {
        "title": "Administracja i finanse",
        "text": "Księgowość, rachunkowość i biurokracja spółki: czytanie, przyporządkowywanie i archiwizowanie dowodów księgowych, z projektami faktur i umów włącznie."
      },
      {
        "title": "Projekty i zadania",
        "text": "Transkrypcja spotkania bez okrężnych dróg staje się zadaniami w zarządzaniu projektami, a postęp spływa z powrotem: następne spotkanie zaczyna się od aktualnego stanu."
      },
      {
        "title": "Wiedza firmowa",
        "text": "Baza wiedzy dla dokumentów i grafowa baza danych, która łączy zadania, decyzje, osoby i systemy: kontekst w skali tygodni i ponad granicami projektów."
      },
      {
        "title": "Research w internecie",
        "text": "Czego nie ma w wiedzy firmowej, to zostaje zbadane: wyszukiwanie, lektura najlepszych stron, a na końcu raport, w którym każde twierdzenie ma swoje numerowane źródło."
      },
      {
        "title": "Mowa i spotkania",
        "text": "Całą firmą można kierować mobilnie: rozmowy głosowe załatwiają te same zadania co czat, także w drodze, przez telefon."
      },
      {
        "title": "Praca biurowa z RoBuddy",
        "text": "RoBuddy obsługuje stanowisko pracy: terminy, e-maile, szkolenia i pytania o ochronę danych. Jednostki obsługują resztę przedsiębiorstwa."
      }
    ]
  },
  "operate": {
    "title": "Wdrożenie i eksploatacja",
    "cards": [
      {
        "title": "On-premises lub własna chmura",
        "text": "Najpierw wspólnie liczymy, które procesy się opłacają: zwrot z inwestycji i koszt całkowity są jawne. Całość działa na Państwa sprzęcie lub w Państwa własnej chmurze, a żaden dokument nie opuszcza firmy."
      },
      {
        "title": "U nas",
        "text": "pAIoneer Labs GmbH jest od podstaw tak zbudowana: na tym działają nasze projekty, nasza wiedza firmowa i nasza administracja. Organizacja sama rozwija [asystenta tradingowego](finance) naszej platformy, a w czacie jest jego AI."
      }
    ]
  },
  "cta": {
    "title": "Zapytanie",
    "subtitle": "Jako oprogramowanie serwerowe w Państwa infrastrukturze. Cenę podajemy na zapytanie.",
    "button": "Wyślij zapytanie",
    "subject": "Veridion Agentic Company Intelligence"
  }
};
